<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
  font-size: 14px !important;
  text-align: right;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.legend-con {
  font-family: "Prompt", sans-serif !important;
  display: inline-block;

  ul {
    list-style: none;
  }

  li {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    span {
      display: inline-block;
    }

    span.chart-legend {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
}
.v-data-table__wrapper > table > thead > tr {
  background-color: #039be5;
}
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  color: white !important;
}
</style>

<template>
  <v-container fluid>
    <div
      class="text-h4 font-weight-black primary--text text-spacing"
      color="blue"
    >
      รายงานใบวางบิล
    </div>
    <v-divider class="my-2"></v-divider>
    <v-row class="my-1">
      <v-col cols="12" lg="6" class="text-left mt-6">
        <v-text-field
          v-model="search"
          outlined
          prepend-icon="mdi-magnify"
          label="ค้นหาสถานบริการ,จังหวัด,ประเภทสถานบริการ"
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="6" class="text-right mt-6">
        <v-btn large color="default" @click="export_bill()">
          <v-icon left dark> mdi-printer </v-icon>ดาวน์โหลด Excel
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="getIndex"
      :search="search"
      item-key="index"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.index }}</td>
          <td>{{ item.CUSTOMER_GROUP }}</td>
          <td>{{ item.CUSTOMER_NAME }}</td>
          <td>{{ item.CUSTOMER_PROVINCE }}</td>
          <td>{{ item.WALKOUT_DATE | formatDate }}</td>
          <td>{{ item.TOTAL_WEIGHT | delimeter }}</td>
        </tr>
      </template>
      <template slot="body.append">
        <tr>
          <th colspan="2" class="text-h5 font-weight-black primary--text">
            จำนวนรวมทั้งหมด
          </th>

          <th></th>
          <th></th>
          <th></th>
          <th class="text-h5 font-weight-black primary--text">
            {{ sumField("TOTAL_WEIGHT") | delimeter }}
          </th>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import moment from "moment";
import XLSX from "xlsx";
export default {
  components: {},
  name: "BillReport",
  data: () => ({
    time3: new Date(),
    isvat: "เสียภาษี",
    province: "",
    search: "",
    headers: [
      {
        text: "ลำดับ",
        align: "left",
        sortable: true,
        value: "index",
      },
      { text: "ประเภท", value: "CONTRACT_CATEGORY", align: "left" },
      { text: "สถานบริการ", value: "CUSTOMER_NAME", align: "left" },
      { text: "จังหวัด", value: "CUSTOMER_PROVINCE", align: "left" },
      { text: "วันที่", value: "WALKOUT_DATE", align: "left" },
      { text: "จำนวน (กก.)", value: "TOTAL_WEIGHT", align: "left" },
    ],
    table_data: [],
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    now_Date: new Date(),
  }),
  watch: {},
  created() {
    // for (let i = 0; i < 5; i++) {
    //   console.log(this.$route.params.l_mas.split('&')[i] +'---'+i );

    // }

    let month = this.$route.params.l_mas.split("&")[1];
    let year = this.$route.params.l_mas.split("&")[2];
    let province = this.$route.params.l_mas.split("&")[3];
    let type = this.$route.params.l_mas.split("&")[4];

    this.LOADER(true);
    this.$guest_api
      .get(`/bill-report-anamai/${month}/${year}/${province}/${type}`)
      .then((res) => {
        let data = res.data.data;
        this.table_data = data;
        this.LOADER(false);
      })
      .catch((err) => {
        this.LOADER(false);
      });
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x;
    },
    formatDate(data) {
      return moment(data).add(543, "year").format("DD-MM-YYYY");
    },
  },
  computed: {
    getIndex() {
      return this.table_data.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
    },
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
    }),
    sumField(key) {
      return this.table_data.reduce((a, b) => a + (b[key] || 0), 0);
    },

    export_bill() {
      this.LOADER(true);
      let data = this.getIndex;
      let xls_json = [];
      if (data.length > 0) {
        data.forEach((element) => {
          xls_json.push({
            ลำดับ: element.index,
            ประเภท: element.CUSTOMER_GROUP,
            สถานบริการ: element.CUSTOMER_NAME,
            จังหวัด: element.CUSTOMER_PROVINCE,
            วันที่: moment(element.WALKOUT_DATE).format("DD-MM-YYYY"),
            "จำนวนน้ำหนัก (กก.)": element.TOTAL_WEIGHT,
          });
        });
        var wscols = [
          { width: 5 }, // first column
          { width: 20 }, // second column
          { width: 50 }, //...
          { width: 20 },
          { width: 18 },
          { width: 18 },
        ];
        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        dataWS["!cols"] = wscols;
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(
          wb,
          `รายงานใบวางบิล_${moment().format("DD-MM-YYYY")}.xlsx`
        );
        this.LOADER(false);
      } else {
        this.LOADER(false);
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาเลือกเดือนที่มีข้อมูลรายงาน`,
          timer: 2000,
        });
      }
    },
  },

  mounted() {},
};
</script>